export const SCORE_VERY_WEAK = 0;

export const SCORE_WEAK = 1;

export const SCORE_UNSAFE = 2;

export const SCORE_MODERATE = 3;

export const SCORE_STRONG = 4;


export const SCORES = [
    SCORE_VERY_WEAK,
    SCORE_WEAK,
    SCORE_UNSAFE,
    SCORE_MODERATE,
    SCORE_STRONG
];


export const SCORE_TO_PERCENTAGE = {
    [SCORE_VERY_WEAK]: 20,
    [SCORE_WEAK]: 40,
    [SCORE_UNSAFE]: 60,
    [SCORE_MODERATE]: 80,
    [SCORE_STRONG]: 100
};
